/**
 * ss-cart-page.js — AJAX cart with animations (v30)
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ss-cart]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
  var toastEl = root.querySelector('[data-ss-cart-toast]');
  var noteTimer = null;
  var queue = Promise.resolve();

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withNoDecimals = String(Math.round(Math.abs(cents) / 100));
    var formatted = moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withNoDecimals);
    return cents < 0 ? '-' + formatted : formatted;
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    toastEl.classList.add('is-show');
    clearTimeout(toast.t);
    toast.t = setTimeout(function () {
      toastEl.classList.remove('is-show');
      toastEl.hidden = true;
    }, 2200);
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], .ss-cart-count').forEach(function (el) {
      el.textContent = String(count);
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      if (count > 0) el.classList.remove('hidden');
      else el.classList.add('hidden');
      el.classList.add('ss-cart-pulse');
      setTimeout(function () { el.classList.remove('ss-cart-pulse'); }, 500);
    });
    var countLabel = root.querySelector('[data-ss-cart-count]');
    if (countLabel) countLabel.textContent = String(count);
  }

  function updateShipBar(cart) {
    var bar = root.querySelector('[data-ss-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    var fill = bar.querySelector('[data-ss-ship-fill]');
    var msg = bar.querySelector('[data-ss-ship-msg]');
    if (!threshold) return;
    var total = cart.total_price || 0;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, (total / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (remaining === 0) {
        msg.innerHTML = 'You’ve unlocked free shipping';
      } else {
        msg.innerHTML = 'You’re <strong data-ss-ship-remaining>' + formatMoney(remaining) + '</strong> away from free shipping';
      }
    }
  }

  function endpoint(name, fallback) {
    var base = (window.routes && window.routes[name]) || fallback;
    return /\.js(\?|$)/.test(base) ? base : base + '.js';
  }

  function changeLine(key, quantity) {
    queue = queue.then(function () {
      root.classList.add('is-busy');
      return fetch(endpoint('cart_change_url', '/cart/change'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) {
              var err = new Error((data && (data.description || data.message)) || 'Could not update cart');
              err.payload = data;
              throw err;
            }
            return data;
          });
        })
        .then(function (cart) {
          if (!cart.item_count) {
            window.location.reload();
            return cart;
          }
          syncFromCart(cart, key, quantity);
          updateHeaderCount(cart.item_count);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ss-cart', cart: cart });
          }
          if (typeof window.ssRefreshCart === 'function') {
            try { window.ssRefreshCart(); } catch (e) {}
          }
          return cart;
        })
        .catch(function (err) {
          toast((err && err.message) || 'Could not update cart');
        })
        .finally(function () {
          root.classList.remove('is-busy');
        });
    });
    return queue;
  }

  function syncFromCart(cart, changedKey, qty) {
    var sub = root.querySelector('[data-ss-cart-subtotal]');
    var tot = root.querySelector('[data-ss-cart-total]');
    if (sub) {
      sub.textContent = formatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      sub.classList.add('ss-cart__flash');
      setTimeout(function () { sub.classList.remove('ss-cart__flash'); }, 400);
    }
    if (tot) {
      tot.textContent = formatMoney(cart.total_price);
      tot.classList.add('ss-cart__flash');
      setTimeout(function () { tot.classList.remove('ss-cart__flash'); }, 400);
    }

    var keys = {};
    (cart.items || []).forEach(function (item) {
      keys[item.key] = item;
      var row = root.querySelector('.ss-cart__item[data-key="' + item.key.replace(/"/g, '\\"') + '"]');
      if (!row) return;
      var input = row.querySelector('[data-ss-qty-input]');
      var price = row.querySelector('[data-line-price]');
      if (input) input.value = item.quantity;
      if (price) {
        var html = '';
        if (item.original_line_price && item.original_line_price !== item.final_line_price) {
          html += '<s>' + formatMoney(item.original_line_price) + '</s>';
        }
        html += formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price);
        price.innerHTML = html;
        price.classList.add('ss-cart__flash');
        setTimeout(function () { price.classList.remove('ss-cart__flash'); }, 400);
      }
    });

    root.querySelectorAll('.ss-cart__item').forEach(function (row) {
      var k = row.getAttribute('data-key');
      if (k && !keys[k]) {
        row.classList.add('is-removing');
        setTimeout(function () { row.remove(); }, 320);
      }
    });

    if (changedKey && qty === 0) {
      var dying = root.querySelector('.ss-cart__item[data-key="' + String(changedKey).replace(/"/g, '\\"') + '"]');
      if (dying) {
        dying.classList.add('is-removing');
        setTimeout(function () { if (dying.parentNode) dying.remove(); }, 320);
      }
    }

    updateShipBar(cart);
  }

  function saveNote(value) {
    fetch(endpoint('cart_update_url', '/cart/update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note: value })
    }).catch(function () {});
  }

  root.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-ss-qty-minus]');
    var plus = e.target.closest('[data-ss-qty-plus]');
    var remove = e.target.closest('[data-ss-remove]');

    if (minus || plus) {
      var wrap = e.target.closest('[data-ss-qty]');
      var item = e.target.closest('.ss-cart__item');
      if (!wrap || !item) return;
      var input = wrap.querySelector('[data-ss-qty-input]');
      var key = item.getAttribute('data-key');
      var qty = parseInt(input.value, 10) || 1;
      qty = minus ? Math.max(0, qty - 1) : qty + 1;
      input.value = qty;
      changeLine(key, qty);
    }

    if (remove) {
      var k = remove.getAttribute('data-key');
      changeLine(k, 0);
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-ss-qty-input]');
    if (!input) return;
    var item = input.closest('.ss-cart__item');
    var key = item && item.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    if (key) changeLine(key, qty);
  });

  var note = root.querySelector('[data-ss-cart-note]');
  if (note) {
    note.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveNote(note.value); }, 500);
    });
  }
})();
